import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['button']

  onClick(event) {
    if (event.params.disable) {
      if (this.buttonTarget.form.checkValidity()) {
        // Disable button on submit.
        // If we'd disable it immediately, it would affect the form submission.
        // This is why we set a tiny timeout before we disable it. UJS does the same when we use
        // data-disable-with, but we don't have jquery/UJS in the builder.
        window.setTimeout(() => {
          this.buttonTarget.disabled = true
        }, 13)

        this.#performCustomerAction()
      }
    } else {
      this.#performCustomerAction()
    }
  }

  #performCustomerAction() {
    const { alsoCustomerActionToken, alsoCustomerActionUrl } =
      this.buttonTarget.dataset
    if (!alsoCustomerActionToken || !alsoCustomerActionUrl) return

    const body = new FormData()
    body.append('token', alsoCustomerActionToken)

    // keepalive lets the request finish even if the click triggers navigation
    void fetch(alsoCustomerActionUrl, {
      method: 'POST',
      keepalive: true,
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')
          ?.content,
        Accept: 'application/json',
      },
      body,
    }).catch(Function.prototype)
  }
}
